var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 6.66667H11.6667C12.5872 6.66667 13.3333 7.41286 13.3333 8.33333C13.3333 9.25383 12.5872 10 11.6667 10M8.33333 6.66667V10M8.33333 6.66667H7.08333M8.33333 6.66667V5.41667M11.6667 10H8.33333M11.6667 10C12.5872 10 13.3333 10.7462 13.3333 11.6667C13.3333 12.5872 12.5872 13.3333 11.6667 13.3333H8.33333M8.33333 10V13.3333M8.33333 13.3333H7.08333M8.33333 13.3333V14.5833M10.8333 6.66667V5.41667M10.8333 14.5833V13.3333M17.5 10C17.5 14.1422 14.1422 17.5 10 17.5C5.85787 17.5 2.5 14.1422 2.5 10C2.5 5.85787 5.85787 2.5 10 2.5C14.1422 2.5 17.5 5.85787 17.5 10Z",
    stroke: "#50515C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactIcon1);
export default __webpack_public_path__ + "static/media/fact-icon1.cc37be311db051d99d86cfa648a8f029.svg";
export { ForwardRef as ReactComponent };